import { useTranslation } from 'react-i18next'
import Tabs from './Tabs'
import AdminClients from './AdminClients'
import AdminFleet from './AdminFleet'
import AdminMines from './AdminMines'
import AdminPits from './AdminPits'
import AdminChecklists from './AdminChecklists'
import AdminEquipe from './AdminEquipe'
import AdminZones from './AdminZones'
import AdminProduction from './AdminProduction'
import AdminIAM from './AdminIAM'
import { useAuth } from '../contexts/AuthContext'

const TABS = [
  { id: 'admin-clientes', key: 'clients' },
  { id: 'admin-minas', key: 'mines' },
  { id: 'admin-pits', key: 'pits' },
  { id: 'admin-frota', key: 'fleet' },
  { id: 'admin-checklists', key: 'checklists' },
  { id: 'admin-equipe', key: 'team' },
  { id: 'admin-zonas', key: 'zones' },
  { id: 'admin-producao', key: 'production' },
  // IAM é quem entra no PAINEL (não confundir com Equipe, que são os operadores do VMC
  // por cartão RFID). Só admin: `role` aqui é o perfil mínimo para a aba aparecer.
  { id: 'admin-iam', key: 'iam', role: 'admin' },
]

// Casca de Administração (Organização) com abas. A aba ativa é a própria view do app
// (sidebar e abas em sincronia).
export default function AdminView({ view, onViewChange }) {
  const { t } = useTranslation()
  const { can } = useAuth()
  const allowed = TABS.filter(tab => !tab.role || can(tab.role))
  const tabs = allowed.map(tab => ({ id: tab.id, label: t(`admin:tabs.${tab.key}`) }))
  return (
    <div className="h-full flex flex-col">
      <Tabs tabs={tabs} active={view} onChange={onViewChange} />
      <div className="flex-1 overflow-hidden">
        {view === 'admin-clientes' && <AdminClients />}
        {view === 'admin-minas' && <AdminMines />}
        {view === 'admin-pits' && <AdminPits />}
        {view === 'admin-frota' && <AdminFleet />}
        {view === 'admin-checklists' && <AdminChecklists />}
        {view === 'admin-equipe' && <AdminEquipe />}
        {view === 'admin-zonas' && <AdminZones />}
        {view === 'admin-producao' && <AdminProduction />}
        {view === 'admin-iam' && can('admin') && <AdminIAM />}
      </div>
    </div>
  )
}
